import React from "react"

import {LexicalEditor} from "lexical"
import ControlButtonStandard from "../../../../../buttons/control-button/control-button-standard"
import {lexicalInsertMentionTrigger} from "../../../../actions/insert-mention-trigger"
import {lexicalInsertLink} from "../../../../actions/insert-link"
import {FontColorType} from "../../../highlight/font-color/font-color-plugin"
import {BadgeType} from "../../../highlight/badge/badge-plugin"
import ButtonAddAttachmentControlButton from "../../../../../files/add-attachment-button/control-button"
// import PopupMenuButton from "../../../../../popover-menu/popup-menu-button/popup-menu-button"
// import ToolbarInsertButton from "../insert/insert-button"
// import ToolbarInsertMenu from "../insert/insert-menu"

type Props = {
    editor              : LexicalEditor
    fontColorType?      : FontColorType | null
    badgeType?          : BadgeType | null
    onAddAttachment?    : {(type: 'local' | 'google-drive'):void}
}

export default function CombinedToolbar(props: Props): JSX.Element {
    const onClickMention = () => {
        lexicalInsertMentionTrigger(props.editor)
    }

    const onClickLink = () => {
        lexicalInsertLink(props.editor)
    }

    return (
        <>
            {props.onAddAttachment &&
                <ButtonAddAttachmentControlButton onSelect={props.onAddAttachment}/>}

            <ControlButtonStandard  iconClass   = "editor-i5-mention fs-16"
                                    onClick     = {onClickMention}/>

            <ControlButtonStandard  iconClass   = "editor-i5-link fs-16"
                                    onClick     = {onClickLink}/>

            {/*<PopupMenuButton btnComponent   = {ToolbarInsertButton}*/}
            {/*                 menuComponent  = {ToolbarInsertMenu}*/}
            {/*                 menuParams     = {{*/}
            {/*                     editor: props.editor*/}
            {/*                 }}/>*/}
        </>
    )
}